<template>
  <div>
    <!-- View -->
    <a-modal v-model="visible" title="Student Information" :width="this.settings['isMobileView'] ? 480 : this.settings['isTabletView'] ? 720 : 1080" style="top: 20px;">
        <template slot="footer">
            <a-button key="back" @click="handleCancel">Close</a-button>
        </template>
        <a-skeleton active :title="false" :paragraph="{rows: 20}" :loading="loading"/>
        <div v-if="!loading">
            <div class="row mb-4">
                <div class="col-12 col-md-8">
                    <div class="row px-3">
                        <div>
                            <a-avatar shape="square" :size="96" :icon="studentData.photo ? '' : 'user'" :src="studentData.photo"/>
                        </div>
                        <div class="px-3">
                            <p class="h4 font-weight-bold mb-1">{{studentData.first_name}} {{studentData.last_name}}</p>
                            <p class="font-weight-bold mb-0">Student Code: {{studentData.student_code}}</p>
                            <p class="font-weight-bold mb-0">
                                Class: {{studentData.enrollment ? studentData.enrollment.school_class ? studentData.enrollment.school_class.name : '' : ''}}
                                <span class="mr-3"></span>
                                Section: {{studentData.enrollment ? studentData.enrollment.section ? studentData.enrollment.section.name : '' : ''}}
                            </p>
                            <p class="font-weight-bold mb-0">Roll No: {{studentData.enrollment ? studentData.enrollment.roll_no : ''}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 text-right mt-3 mt-md-0">
                  <!-- <a href="javascript:;" class="btn btn-sm btn-dark btn-with-addon mr-2"
                    @click="handlePrint(studentData)"
                  >
                    <span class="btn-addon">
                      <i class="btn-addon-icon fe fe-printer" />
                    </span>
                    Print
                  </a> -->
                  <a href="javascript:;" v-if="rolesetting.editable" class="btn btn-sm btn-primary btn-with-addon mr-2"
                    @click="handleEditClick(studentData)"
                  >
                    <span class="btn-addon">
                      <i class="btn-addon-icon fe fe-edit" />
                    </span>
                    Edit
                  </a>
                  <a href="javascript:;" v-if="rolesetting.deletable" class="btn btn-sm btn-danger btn-with-addon mr-2"
                    @click="onDelete(studentData)"
                  >
                    <span class="btn-addon">
                      <i class="btn-addon-icon fe fe-trash" />
                    </span>
                    Delete
                  </a>
                </div>
            </div>
            <a-divider />
            <!-- Basic Details -->
            <div class="pt-2">
                <div class="mb-2">
                    <p class="h6 text-muted">Basic Details:</p>
                </div>
                <div class="row">
                    <div class="col-6 col-md-4 pb-3" v-for="(item, index) in basicInfo" :key="index">
                        <div class="mb-1">{{index}} :</div>
                        <div>
                            <strong class="h5 font-weight-bold">{{item}}</strong>
                        </div>
                    </div>
                </div>
                <a-divider />
            </div>
            <!-- Contact Details -->
            <div class="pt-2">
                <div class="mb-2">
                    <p class="h6 text-muted">Contact Details:</p>
                </div>
                <div class="row">
                    <div class="col-6 col-md-4 pb-3" v-for="(item, index) in contactInfo" :key="index">
                        <div class="mb-1">{{index}} :</div>
                        <div>
                            <strong class="h5 font-weight-bold">{{item}}</strong>
                        </div>
                    </div>
                </div>
                <a-divider />
            </div>
            <!-- Academic Details -->
            <div class="pt-2">
                <div class="mb-2">
                    <p class="h6 text-muted">Academic Details:</p>
                </div>
                <div class="row">
                    <div class="col-6 col-md-4 pb-3" v-for="(item, index) in academicInfo" :key="index">
                        <div class="mb-1">{{index}} :</div>
                        <div>
                            <strong class="h5 font-weight-bold">{{item}}</strong>
                        </div>
                    </div>
                </div>
                <a-divider />
            </div>
            <!-- Electives Details -->
            <div class="pt-2">
                <div class="mb-2">
                    <p class="h6 text-muted">Elective Subjects:</p>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6 pb-3" v-for="(item, index) in electivesInfo" :key="index">
                        <div class="mb-1">{{index}} : <strong class="h5 font-weight-bold ml-3">{{item}}</strong></div>
                    </div>
                </div>
                <a-divider />
            </div>
            <!-- Previous School Details -->
            <div class="pt-2">
                <div class="mb-2">
                    <p class="h6 text-muted">Previous Academic Details:</p>
                </div>
                <div class="row">
                    <div class="col-6 col-md-4 pb-3" v-for="(item, index) in previousSchoolInfo" :key="index">
                        <div class="mb-1">{{index}} :</div>
                        <div>
                            <strong class="h5 font-weight-bold">{{item}}</strong>
                        </div>
                    </div>
                </div>
                <a-divider />
            </div>
            <!-- Parent Details -->
            <div class="pt-2">
                <div class="mb-2">
                    <p class="h6 text-muted">Parent Details:</p>
                </div>
                <div class="row">
                    <div class="col-6 col-md-4 pb-3" v-for="(item, index) in parentInfo" :key="index">
                        <div class="mb-1">{{index}} :</div>
                        <div>
                            <strong class="h5 font-weight-bold">{{item.first_name}} {{item.last_name}}</strong>
                        </div>
                        <div class="mt-2" v-if="item.first_name">
                            <show-parent :parentData="item"/>
                        </div>
                    </div>
                </div>
                <a-divider />
            </div>
            <!-- Medical Details -->
            <div class="pt-2">
                <div class="mb-2">
                    <p class="h6 text-muted">Medical History:</p>
                </div>
                <div class="row">
                    <div class="col-6 col-md-4" v-for="(item, index) in medicalInfo" :key="index">
                        <div class="mb-1">{{index}} :</div>
                        <div>
                            <strong class="h5 font-weight-bold">{{item}}</strong>
                        </div>
                    </div>
                    <div class="col-12 text-right">
                        <medical-history :medicalData="studentData ? studentData.medical_history : ''"/>
                    </div>
                </div>
            </div>
            <!-- Other Informations -->
            <div class="pt-2">
              <div class="mb-2">
                <p class="h6 text-muted">Other Informations:</p>
              </div>
              <div class="row">
                <div class="col-6 col-md-4" v-for="(item, index) in otherInfo" :key="index">
                  <div class="mb-1">{{index}} :</div>
                  <div>
                    <strong class="h5 font-weight-bold">{{item}}</strong>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </a-modal>
  </div>
</template>

<script>
import { find } from 'lodash'
import { mapState } from 'vuex'
import ShowParent from '../Parent/index'
import MedicalHistory from '../Medical/index'
import { basicInfo, contactInfo, academicInfo, electivesInfo, previousSchoolInfo, parentInfo, medicalInfo, otherInfo } from './data'

export default {
  name: 'StudentInfo',
  components: {
    ShowParent,
    MedicalHistory,
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      schoolSessions: [],
      studentData: {},
      basicInfo: {},
      contactInfo: {},
      academicInfo: {},
      electivesInfo: {},
      previousSchoolInfo: {},
      parentInfo: {},
      medicalInfo: {},
      otherInfo: {},
      currentSession: '',
    }
  },
  props: ['session', 'rolesetting'],
  // props: {
  //   session: { type: Number },
  //   rolesetting: { type: Object },
  // },
  computed: {
    ...mapState(['settings', 'user']),
  },
  mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.currentSession = find(this.schoolSessions, ['is_current', 1])
      })
      .catch(error => {
        console.log(error)
      })
    this.$eventBus.$on('openStudentShowModal', this.showModal)
  },
  methods: {
    showModal(studentId) {
      this.studentId = studentId
      this.visible = true
      this.loading = true
      this.$http.get(`/api/student/${this.studentId}`, {
        params: {
          session_id: this.session,
        },
      })
        .then(({ data }) => {
          this.studentData = data.data
          this.basicInfo = basicInfo(data.data)
          this.contactInfo = contactInfo(data.data.contact)
          this.academicInfo = academicInfo(data.data.enrollment, this.currentSession)
          this.electivesInfo = electivesInfo(data.data.student_elective_subjects)
          this.previousSchoolInfo = previousSchoolInfo(data.data)
          this.parentInfo = parentInfo(data.data.student_parents)
          this.medicalInfo = medicalInfo(data.data)
          this.otherInfo = otherInfo(data.data)
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    handlePrint(student) {
      console.log('Print')
    },
    handleEditClick(student) {
      this.$emit('editClick', student.id)
      this.visible = false
    },
    onDelete: function(record) {
      this.$confirm({
        title: `Are you sure?`,
        content: `Clicking Yes will delete ${record.first_name} ${record.last_name}?`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/student/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.first_name + ' ' + record.last_name + ' has been deleted.',
              })
              this.visible = false
            })
            .catch(error => {
              this.$nprogress.done()
              this.$notification['error']({
                message: error.message,
                description: 'Unable to delete student. Please try again.',
              })
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    handleCancel(e) {
      this.visible = false
    },
  },
}
</script>
